import type { IApp } from "@/types";
import { computed } from "vue";
import { useRoute } from "vue-router";

const useRouteParams = () => {
  const route = useRoute();
  const sourceId = computed(() => route.params.sourceId as string | undefined);
  const customerId = computed(() => route.params.customerId as string | undefined);
  const feed = computed(() => route.params.feed as IApp.IFeedTypes | undefined);

  return {
    sourceId,
    customerId,
    feed
  };
};

export default useRouteParams;
